import actionTypes from "./actionTypes";
import * as registerUtils from "../utils/registerUtils";

const registerRequest = () => ({
  type: actionTypes.CREATE_USER_REQUEST,
});
const registerSuccess = (res) => ({
  type: actionTypes.CREATE_USER_SUCCESS,
  res,
});
const registerFailure = (error) => ({
  type: actionTypes.CREATE_USER_FAILURE,
  error,
});
export const register = (data, googleBtnClicked = false) => {
  return async (dispatch) => {
    try {
      dispatch(registerRequest());
      let res = await registerUtils.register(data, googleBtnClicked);
      dispatch(registerSuccess(res));
    } catch (error) {
      dispatch(registerFailure(error));
    }
  };
};
